import React from "react";
import { Link } from "react-router-dom";

const AccreditationsGallery = () => {
  return (
    <div className="ucwf-container">
      <div className="ucwf-gallery-wrapper d-flex justify-content-center">
        {/* <div className="ucwf-gallery-cards"> */}
          {/* Awards Card */}
          {/* <Link to="/gallery" className="ucwf-gallery-card-link">
            <div className="ucwf-gallery-card">
              <div className="ucwf-gallery-image">
                <img
                  src="/images/galleryucwf/tabs/awards-tab.webp"
                  alt="Awards Gallery"
                  className="ucwf-img-fluid"
                />
                <div className="ucwf-gallery-title">
                  Awards
                </div>
              </div>
            </div>
          </Link> */}

          {/* Celebrations Card */}
          {/* <Link to="/gallery" className="ucwf-gallery-card-link">
            <div className="ucwf-gallery-card">
              <div className="ucwf-gallery-image">
                <img
                  src="/images/galleryucwf/tabs/celebrations-tab.webp"
                  alt="Celebrations Gallery"
                  className="ucwf-img-fluid"
                />
                <div className="ucwf-gallery-title">
                  Celebrations
                </div>
              </div>
            </div>
          </Link> */}

          {/* Housekeeping Card - Will be hidden on small screens via CSS */}
          {/* <Link to="/gallery" className="ucwf-gallery-card-link housekeeping-card">
            <div className="ucwf-gallery-card">
              <div className="ucwf-gallery-image">
                <img
                  src="/images/galleryucwf/tabs/housekeeping-tab.webp"
                  alt="HousekeepingCrew Gallery"
                  className="ucwf-img-fluid"
                />
                <div className="ucwf-gallery-title">
                  Housekeeping Crew
                </div>
              </div>
            </div>
          </Link> */}
        {/* </div> */}
        
        {/* View Gallery Button */}
        <div className="ucwf-gallery-button">
          <Link to="/gallery" className="ucwf-btn">
            View Gallery
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccreditationsGallery;